import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl } from "network";

export const blogApi = createApi({
    reducerPath: "blogApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.token;
            if (token) {
                
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllBlogs: builder.query({
            query: ({ page, limit, search }) => ({
                url: `admin-blog/list?page=${page}&limit=${limit}&search=${search}`
            }),
            transformResponse: (response) => response.data
        }),
        addBlog: builder.mutation({
            query: (data) => ({ url: `admin-blog/add`, method: "POST", body: data,headers: {
                "Content-Type": "application/json",
              } }),
        }),
        getAllBlogsById: builder.query({
            query: ({ id }) => ({
                url: `admin-blog/blogById?id=${id}`
            }),
            transformResponse: (response) => response.data
        }),
        updateBlog: builder.mutation({
            query: ({id,formData}) => ({ url: `admin-blog/update/${id}`, method: "PUT", body: formData,headers: {
                "Content-Type": "application/json",
            } }),
        }),
    })
})

export const { useGetAllBlogsQuery, useAddBlogMutation, useGetAllBlogsByIdQuery, useUpdateBlogMutation } = blogApi;
